import React from 'react';
import TransactionLine from "./components/TransactionLine";
import { ClockIcon } from "@heroicons/react/24/solid";

function TransactionList({transactions}) {
    if (!transactions?.length) return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center">
            <p className="text-gray-500 text-lg">No transactions found</p>
        </div>
    );

    let transactionLines = transactions?.map((transaction) => {
        return <TransactionLine key={transaction?.id} transaction={transaction}/>;
    });

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 flex items-center gap-2">
                <ClockIcon className="h-5 w-5 text-blue-600" />
                <div>
                    <h3 className="text-lg leading-6 font-medium text-gray-800">Transaction History</h3>
                    <p className="mt-1 max-w-2xl text-sm text-gray-600">A detailed list of all your transactions</p>
                </div>
            </div>
            <div className="overflow-x-auto">
                <div className="inline-block min-w-full align-middle">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                        <tr>
                            <th key="1" scope="col"
                                className="px-4 py-3.5 first:pl-6 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Invoice Ref
                            </th>
                            <th key="2" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Transaction Id
                            </th>
                            <th key="3" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Auth Code
                            </th>
                            <th key="4" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Card Number
                            </th>
                            <th key="5" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Status
                            </th>
                            <th key="6" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Description
                            </th>
                            <th key="7" scope="col"
                                className="px-4 py-3.5 ltr:text-left rtl:text-right text-xs font-semibold uppercase tracking-wider text-gray-700">
                                Created At
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                        {transactionLines}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default TransactionList;
